import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const changePasswordScheme = z.object({
  email: z.string().email('Email inválido'),
  codigo: z.string().min(4, 'O codigo deve ter 4 caracteres'),
  novaSenha: z
    .string()
    .min(6, 'A senha deve ter no mínimo 6 caracteres')
    .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
    .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
    .regex(/\d/, 'A senha deve conter pelo menos um número')
})

export type changePasswordForm = z.infer<typeof changePasswordScheme>
